import { useState } from 'react';
import { Link } from 'react-router-dom';

// mui
import { Tab, Tabs } from '@mui/material';
import FileDownloadTwoTone from '@mui/icons-material/FileDownloadTwoTone';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';

// project imports
import MainCard from '../../ui-component/cards/MainCard';
import CustomerList from './CustomerList';
import CustomerExport from './CustomerExport';
import useAuth from '../../hooks/useAuth';
import { UserRole } from '../../models/IEmployee';
import TabPanel, { a11yProps } from '../../ui-component/TabPanel';

const CustomerTabs = () => {
    const { user } = useAuth();
    const [value, setValue] = useState(0);

    const isAdminOrOwner = user?.employee.role.name === UserRole.Owner || user?.employee.role.name === UserRole.Admin;

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <MainCard title="Customers" content={false}>
            <div>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    sx={{
                        pl: 3,
                        '& a': {
                            minWidth: 10,
                            py: 1.5,
                            px: 1,
                            mr: 2.25,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        '& a.Mui-selected': {
                            color: 'primary.main'
                        },
                        '& .MuiTabs-indicator': {
                            bottom: 2
                        },
                        '& a > svg': {
                            marginBottom: '0px !important',
                            mr: 1.25
                        }
                    }}
                    aria-label="profile tabs"
                    variant="scrollable"
                >
                    <Tab component={Link} to="#" icon={<PeopleAltOutlined />} label="List" {...a11yProps(0, 'customer')} />
                    {isAdminOrOwner && (
                        <Tab component={Link} to="#" label="Export" icon={<FileDownloadTwoTone />} {...a11yProps(1, 'customer')} />
                    )}
                </Tabs>
                <TabPanel value={value} index={0} prefix="customer">
                    <CustomerList />
                </TabPanel>
                <TabPanel value={value} index={1} prefix="customer">
                    <CustomerExport />
                </TabPanel>
            </div>
        </MainCard>
    );
};

export default CustomerTabs;
